/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Genre_QuestionInputs */

const en_onboarding_genre_question = /** @type {(inputs: Onboarding_Genre_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What genre or type of reading do you usually prefer?`)
};

const es_onboarding_genre_question = /** @type {(inputs: Onboarding_Genre_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué género o tipo de lectura prefieres normalmente?`)
};

/**
* | output |
* | --- |
* | "What genre or type of reading do you usually prefer?" |
*
* @param {Onboarding_Genre_QuestionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_genre_question = /** @type {((inputs?: Onboarding_Genre_QuestionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Genre_QuestionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_genre_question(inputs)
	return en_onboarding_genre_question(inputs)
});